import { MarketLayoutStylesSchema } from './MarketLayout.styles';

export const matchDetailsStyles: MarketLayoutStylesSchema = {
  headerText: {
    flex: '1',
    color: 'gamma.200',
    align: 'center',
    fontSize: '2xs',
    fontWeight: 'bold',
  },
  rowWrapper: {
    mx: '0.5',
    px: '4',
    py: '2',
    alignItems: 'center',
    display: 'flex',
    fontSize: 'xs',
    fontWeight: 'bold',
    fontFamily: 'accent',
    justifyContent: 'space-between',
    borderColor: 'transparent',
    borderTopWidth: undefined,
    gap: '2',
    pos: 'relative',
    color: 'white',
    _before: {
      borderColor: 'blackAlpha.400',
      borderBottomWidth: '1px',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      w: 'full',
      left: '0',
      pos: 'absolute',
      top: '-1px',
    },
  },
  rowWrapperFirst: {
    borderTopWidth: '1px',
    _before: {
      display: 'none',
    },
  },
  rowWrapperWithBtn: {
    borderColor: 'alpha.700',
    borderTopWidth: '1px',
  },
  tab: {
    bg: 'alpha.300',
    color: 'white',
    fontFamily: 'ProximaNova',
    fontSize: 'xs',
    fontWeight: 'extrabold',
    border: '0px',
    borderColor: '#00000040',
    _first: { ml: '4px' },
    _last: { mr: '4px' },
    _notFirst: {
      borderLeftWidth: '1px',
      borderLeftStyle: 'solid',
      borderLeftColor: 'alpha.700',
    },
    _selected: {
      borderBottomColor: 'transparent',
      color: 'gamma.400',
      bg: 'transparent',
    },
  },
};
